import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useCookies } from "react-cookie";
import "../../Vender/css/Destinations.css";

const Pushkar = () => {
  const [cookies] = useCookies(["token", "user", "id"]);

  const [showModal, setShowModal] = useState(false);
  const [amount, setAmount] = useState("");
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone_no, setPhone] = useState("");

  const user_id = cookies.id; // fetch from cookie

  const handlePayment = async () => {
    if (!amount || !name || !email || !phone_no) {
      alert("Please fill in all fields.");
      return;
    }

    try {
      console.log("Creating order with amount:", amount);
      const res = await fetch(
         "/api/payment_details/create-order",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ amount: parseFloat(amount) }),
        }
      );

      if (!res.ok) {
        throw new Error(`API Error: ${res.status} ${res.statusText}`);
      }

      const data = await res.json();
      console.log("Order created:", data);

      if (!data.amount || !data.currency || !data.orderId) {
        throw new Error("Invalid response from server");
      }

      const options = {
       key: process.env.REACT_APP_RAZORPAY_KEY_ID,
        amount: data.amount * 100, // Convert to paise
        currency: data.currency,
        name: "Aacore Resorts And Hospitality Pvt. Ltd.",
        description: "Pushkar Booking",
        order_id: data.orderId,
        handler: async function (response) {
          console.log("Payment response:", response);
          const verifyRes = await fetch(
            "/api/payment_details/verify-payment", 
            {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({
                razorpay_order_id: response.razorpay_order_id,
                razorpay_payment_id: response.razorpay_payment_id,
                razorpay_signature: response.razorpay_signature,
                amount: parseFloat(amount),
                name,
                email,
                phone_no,
                user_id,
              }),
            }
          );

          const verifyData = await verifyRes.json();
          if (verifyData.success) {
            alert("Payment successful 🎉");
            setShowModal(false);
          } else {
            alert("Payment failed ❌");
          }
        },
        prefill: { name, email, contact: phone_no },
        theme: { color: "#3399cc" },
      };

      console.log("Opening Razorpay with options:", options);
      const rzp1 = new window.Razorpay(options);
      rzp1.open();
    } catch (err) {
      console.error("Payment Error:", err);
      alert("Payment initialization failed. Please try again.");
    }
  };

  return (
    <section id="destination">
      <div className="pushkar py-5">
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb">
            <li className="breadcrumb-item text-light">
              <Link to="/" className="text-light">
                Home
              </Link>
            </li>
            <li
              className="breadcrumb-item active text-light"
              aria-current="page"
            >
              Pushkar
            </li>
          </ol>
        </nav>
      </div>

      <div className="container py-5">
        <div className="header">
          <h1 className="text-center">Our Hotel Partners in Pushkar</h1>
        </div>
        <div className="image-container row justify-content-center">
          <div className="col-md-4 mb-4">
            <div className="card">
              <img src="/assets/images/Hotel Pushkar Legacy.jpg" className="card-img-top" alt="Hotel Pushkar Legacy" style={{ height: '200px', width: '100%', objectFit: 'cover' }} />
              <div className="card-body">
                <h5 className="card-title">Hotel Pushkar Legacy</h5>
                <p className="card-text">Hotel Pushkar Legacy offers accommodation of 35 rooms with a restaurant, private parking, Banquet Hall, an outdoor swimming pool, and a garden.</p>
                <button className="btn btn-primary" onClick={() => setShowModal(true)}>Book Now</button>
              </div>
            </div>
          </div>
          <div className="col-md-4 mb-4">
            <div className="card">
              <img src="/assets/images/Pushkar Fort - Luxury Heritage Resort.jpg" className="card-img-top" alt="Pushkar Fort" style={{ height: '200px', width: '100%', objectFit: 'cover' }} />
              <div className="card-body">
                <h5 className="card-title">Pushkar Fort - Luxury Heritage Resort</h5>
                <p className="card-text">Nestled amidst the Aravalli hills, Pushkar Fort offers a blend of heritage and luxury with stunning views of the Pushkar Lake.</p>
                <button className="btn btn-primary" onClick={() => setShowModal(true)}>Book Now</button>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Payment Modal */}
      {showModal && (
        <div className="modal fade show d-block" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }} tabIndex="-1">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Book Pushkar Tour</h5>
                <button type="button" className="btn-close" onClick={() => setShowModal(false)}></button>
              </div>
              <div className="modal-body">
                <form>
                  <div className="mb-3">
                    <label htmlFor="amount" className="form-label">Amount</label>
                    <input
                      type="number"
                      className="form-control"
                      id="amount"
                      value={amount}
                      onChange={(e) => setAmount(e.target.value)}
                      required
                    />
                  </div>
                  <div className="mb-3">
                    <label htmlFor="name" className="form-label">Name</label>
                    <input
                      type="text"
                      className="form-control"
                      id="name"
                      value={name}
                      onChange={(e) => setName(e.target.value)}
                      required
                    />
                  </div>
                  <div className="mb-3">
                    <label htmlFor="email" className="form-label">Email</label>
                    <input
                      type="email"
                      className="form-control"
                      id="email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      required
                    />
                  </div>
                  <div className="mb-3">
                    <label htmlFor="phone" className="form-label">Phone Number</label>
                    <input
                      type="tel"
                      className="form-control"
                      id="phone"
                      value={phone_no}
                      onChange={(e) => setPhone(e.target.value)}
                      required
                    />
                  </div>
                </form>
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-secondary" onClick={() => setShowModal(false)}>Close</button>
                <button type="button" className="btn btn-primary" onClick={handlePayment}>Pay Now</button>
              </div>
            </div>
          </div>
        </div>
      )}
    </section>
  );
};

export default Pushkar;
